import { ComponentProps } from "react";

export const BlastLogo = (props: ComponentProps<"svg">) => {
  return (
    <svg width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Type=Mark">
        <path
          id="Union"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8233 0L10.8688 6.15782L20.2874 13.4723L13.8233 0ZM12.5626 17.1676L18.367 16.6396L17.4623 14.7538L7.86423 7.29977L2.69927 18.0645L9.03341 17.4884L10.875 13.65L12.5626 17.1676ZM14.4962 19.6912L20.3007 19.1633L25.5 30H0L4.51005 20.5996L10.8442 20.0232L8.66156 24.5728H16.8384L14.4962 19.6912Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
